import React, { ReactNode } from 'react';
import { Box } from '@balance-web/box';

export const WidgetContainer = ({ children }: { children: ReactNode }) => {
  return (
    <Box background="base" border="muted" width={400} borderRadius="small">
      {children}
    </Box>
  );
};
